export default {
  data () {
    return {
      editorConfig: {
        theme: 'modern',
        menu: {},
        menubar: false,
        plugins: '',
        height: 300,
        toolbar: false,
        statusbar: false,
        contextmenu: '',
        fontsize_formats: '12pt',
        branding: false,
        paste_data_images: false,
        automatic_uploads: false,
        content_css: process.env.VUE_APP_ROOT_API + '/members/members-branding.css',
        content_css_cors: true,
        content_style: 'body {font-size: 100%}'
      }
    }
  }
}
